/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Ładowanie"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var plPL = Object.assign(TranslationProviderComponent, {
  translations
});

export { plPL as p };
//# sourceMappingURL=pl-PL-CqVI-cgs.js.map
